import createLabelFilter from '@molecules/Table/filters/labeFilter';
import { FilterItem } from '@services';

export interface TableEnterpriseNewsWire {
  id: string;
  title: string;
  url: string;
  label: string | null;
  imageUrl: string | null;
  createdAt: string;
  publishedAt: string;
}

export enum NewsWireLabels {
  PLACE_HOLDER = 'Select Label',
  ANNOUNCEMENT = 'Announcement',
  NEWS = 'News',
}

export const LABEL_OPTIONS_NEWS_WIRE = [
  { value: NewsWireLabels.NEWS, label: NewsWireLabels.NEWS },
  { value: NewsWireLabels.ANNOUNCEMENT, label: NewsWireLabels.ANNOUNCEMENT },
];

const labelFilterNewsWire = createLabelFilter({ options: LABEL_OPTIONS_NEWS_WIRE });

export const FILTERS_LIST_NEWS_WIRE: FilterItem[] = [labelFilterNewsWire];
